<form nz-form style="padding-top:12px;padding-right:12px" autocomplete="off">
  <div nz-row [nzGutter]="24">
    <div nz-col nzSpan="6">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzRequired>Năm</nz-form-label>
        <asc-autocomplete [ascModel]="CourseControl" (ascModelChange)="changeCourse($event)"
          [placeholder]="'Chọn năm...'" [getListAC]="getCourseACFn"></asc-autocomplete>
      </nz-form-item>
    </div>
    <div nz-col nzSpan="18">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzRequired>Cơ sở</nz-form-label>
        <asc-autocomplete [disabled]="true" [ascModel]="SchoolControl" (ascModelChange)="changeSchool($event)"
          [placeholder]="'Chọn cơ sở...'" [getListAC]="getSchoolACFn"></asc-autocomplete>
      </nz-form-item>
    </div>
    <div nz-col nzSpan="12">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzRequired>Tình trạng giáo dục</nz-form-label>
        <asc-autocomplete [ascModel]="caDisEducationalStatusesControl"
          (ascModelChange)="changeCaDisEducationalStatuses($event)" placeholder="Chọn tình trạng giáo dục..."
          [getListAC]="getCaDisEducationalStatusessACFn">
        </asc-autocomplete>
      </nz-form-item>
    </div>
    <div nz-col nzSpan="12">
      <nz-form-item>
        <nz-form-label nzSpan="24">Cấp học</nz-form-label>
        <asc-autocomplete [ascModel]="DisSchoolLevelsControl" (ascModelChange)="changeDisSchoolLevels($event)"
          placeholder="Chọn cấp học, trình độ đào tạo..." [getListAC]="getDisSchoolLevelsACFn">
        </asc-autocomplete>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24">Lớp</nz-form-label>
        <input nz-input [(ngModel)]="itemQTHT.studyingClassYear" [ngModelOptions]="{standalone: true}" type="text"
          placeholder="Nhập lớp...">
      </nz-form-item>
    </div>

    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24">Giáo viên phụ trách</nz-form-label>
        <asc-autocomplete [ascModel]="StaffControl" (ascModelChange)="changeStaff($event)"
          [placeholder]="'Chọn giáo viên phụ trách...'" [getListAC]="getStaffACFn"></asc-autocomplete>
      </nz-form-item>
    </div>

    <div nz-col nzSpan="12">
      <nz-form-item>
        <nz-form-label nzSpan="24">Chương trình học</nz-form-label>
        <asc-autocomplete [ascModel]="ChuongTrinhHocControl" (ascModelChange)="getChuongTrinhHocACFn($event)"
          [placeholder]="'Chọn chương trình học...'" [getListAC]="getChuongTrinhHocACFn"></asc-autocomplete>
      </nz-form-item>
    </div>

    <div nz-col nzSpan="12">
      <nz-form-item>
        <nz-form-label nzSpan="24">Kết quả</nz-form-label>
        <asc-autocomplete [ascModel]="ResultControl" (ascModelChange)="changeResult($event)"
          [placeholder]="'Chọn Kết quả...'" [getListAC]="getResultACFn">
        </asc-autocomplete>
      </nz-form-item>
    </div>

    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24">Ghi chú</nz-form-label>
        <input nz-input [(ngModel)]="itemQTHT.note" [ngModelOptions]="{standalone: true}" type="text"
          placeholder="Nhập ghi chú...">
      </nz-form-item>
    </div>
  </div>
  <div *nzModalFooter>
    <div *ngIf="!isEditMode" class="card-footer text-right">
      <button nz-button (click)="close()" [disabled]="isDisabled">Đóng</button>&nbsp;
      <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Lưu &
        Đóng</button>
    </div>
    <div *ngIf="isEditMode" class="card-footer text-right">
      <button nz-button (click)="close()" [disabled]="isDisabled">Đóng</button>&nbsp;
      <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Sửa</button>
    </div>
  </div>
</form>
